var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.status === _vm.$constants.POI_STATUSES.NEW)?[(_vm.countVideo > 0)?_c('v-icon',[_vm._v(" mdi-timer-sand ")]):_vm._e()]:(_vm.status === _vm.$constants.POI_STATUSES.IN_REVIEW)?_c('v-icon',{attrs:{"color":"orange darken-1"}},[_vm._v(" mdi-file-eye ")]):_c('v-icon',{attrs:{"color":"teal darken-3"}},[_vm._v(" mdi-check-circle ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }